import script from "./AppointmentsView.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppointmentsView.vue?vue&type=script&lang=ts&setup=true"

import "./AppointmentsView.vue?vue&type=style&index=0&id=81aba20c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-81aba20c"]])

export default __exports__